import { CommonBusinessObject, ValidBusinessObject } from '../datastoreProxy'
import { HistoryObjectType } from '../StateManagement'

export enum DataLifeCycleRequestType {
  STORE = 'STORE',
  RECORD_STATE_HISTORY = 'RECORD_STATE_HISTORY',
  ACCUMLUATE = 'ACCUMULATE',
  PERIODIZE = 'PERIODIZE',
}

export enum DataLifecycleStage {
  SHORT = 'SHORT',
  MEDIUM = 'MEDIUM',
  LONG = 'LONG',
}

export enum DataLifecycleDestination {
  S3 = 'S3',
  S3_Glacier = 'S3_Glacier',
}

export enum Reason {
  TTL_EXPIRED = 'TTL_EXPIRED',
  DELETED_BY_US = 'DELETED_BY_US',
  STATE_HISTORY = 'STATE_HISTORY',
  USER_DELETION = 'USER_DELETION',
  STORE_PAYLOAD = 'STORE_PAYLOAD',
  STORE_NETWORK_DEVICE_DATA = 'STORE_NETWORK_DEVICE_DATA',
}

export type DataLifecycleSQSMessageAttributes = {
  eventName: DataLifeCycleRequestType
  sk: string
}

export type DataLifecycleActionRequest<T = any> = {
  Object: T
  Key?: string
  Destination: DataLifecycleDestination
  BucketName?: string
  ExpiryTimeMS: number
  Stage: DataLifecycleStage
  Reason?: Reason
}
/**
 * Compact time record for hex string payload used to store in time ordered s3 bucket.
 * t: timestamp in millisecods
 * p: hex string payload no spaces
 */
export type DLCPayloadStoreObject = {
  t: number
  p: string
}

export type DLCStateHistoryObject = {
  item: ValidBusinessObject
  stateMap: { [k: string]: any }
}

export const isDLCPayloadStoreRequest = (request: DataLifecycleActionRequest): request is DataLifecycleActionRequest<DLCPayloadStoreObject> => {
  return (request as DataLifecycleActionRequest<DLCPayloadStoreObject>).Reason === Reason.STORE_PAYLOAD
}

/** WRONGLY TYPED */
export const isDLCNetworkDataStoreRequest = (request: DataLifecycleActionRequest): request is DataLifecycleActionRequest<DLCPayloadStoreObject> => {
  return (request as DataLifecycleActionRequest<DLCPayloadStoreObject>).Reason === Reason.STORE_NETWORK_DEVICE_DATA
}

export type HistoryEnabledValidBusinesObject = Required<CommonBusinessObject> & {
  stateHistory: HistoryObjectType
}

export const isHistoryObject = (object: any): object is HistoryObjectType => {
  const po = object as HistoryObjectType

  return !!po && po.index && po.timestamp !== undefined && po.index instanceof Array && po.timestamp instanceof Array
}

export const isHistoryEnabled = (object: any): object is HistoryEnabledValidBusinesObject => {
  const possibleHistoryEnabldeObject = object as HistoryEnabledValidBusinesObject
  return possibleHistoryEnabldeObject.stateHistory !== undefined && isHistoryObject(possibleHistoryEnabldeObject.stateHistory)
}
